import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { RULE_REC_TYPE } from '../../../constants';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import ConcurrencyPopUp from '../../ConcurrencyPopUp/ConcurrencyPopUp';
import { FuseConsoleCardFooter } from '../../ConsoleFragments';
import { FTBody, Page, Card, FTHeading } from '../../Fuse';
import StackL from '../../Spacers/Spacers';
import { TStrong } from '../../Text/Text';
import PolicyTable from '../PolicyTable';
import PriorityModal from '../PriorityModal';
import ExclusionRulesModal from './ExclusionRulesModal';
import ConsoleStore from '../../../stores/ConsoleStore';
import { ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import BrowsingRoleModal from '../BrowsingRoles/BrowsingRoleModal';
import CustomCategoriesModal from '../CustomCategories/CustomCategoriesModal';

class ExclusionRules extends Component {
    static propTypes = {
        console: ConsoleStore.PropType,
        policy: PolicyStore.PropType.isRequired,
    };

    componentDidMount = () => {
        this.props.policy.exclusionRules.policyTable.policyModal.sections.matchCriteria.preload();
    }

    renderTable = (priorityMode) =>
        <PolicyTable
            defaultItemSuffix={'All Pages'}
            changePriorityAction
            store={this.props.policy.exclusionRules.policyTable}
            priorityMode={priorityMode}
            searchPlaceholder="Search by Name"
            noItemsText="adding an Exclusion Rule"
            itemName="Rule"
            itemNameFull="Exclusion Rule"
            readOnly={this.props.console.authority === ROLE_READ_ONLY.value}
            loadFailedMessage="Failed to load Exclusion Rules."
        />

    renderAboutSection = () => {
        return <Card title="What are Exclusion Rules?">
            <FTBody>Exclusion Rules prevent specific sites from opening in Isolation.</FTBody>
            <StackL />
            <FTHeading>When are Exclusion Rules Applied?</FTHeading>
            <StackL />
            <FTBody>
                When a user requests a URL, the system detects the request attributes and applies a Policy.
                The system always checks for a matching Exclusion Rule first.
                If there is a match, the URL opens on the user’s native browser.
            </FTBody>
            <StackL />
            <FTBody>
                Exclusion Rules are checked when a user clicks on TAP URL, requests a URL in Isolation,
                or if a URL request redirects to and opens in Isolation.
            </FTBody>
            <StackL />
            <FTBody>
                If no Exclusion Rules match, the system will either check for a matching Redirect Rule or Content Rule,
                depending on the request.
            </FTBody>
            <StackL />
            <FTHeading>How to Use Exclusion Rules</FTHeading>
            <StackL />
            <FTBody><TStrong>
                Step 1. Add Exclusion Rules for specific use cases
            </TStrong></FTBody>
            <StackL />
            <FTBody>Name the Rule and specify its match criteria.</FTBody>
            <StackL />
            <FTBody><TStrong>
                Step 2. Stack-rank Exclusion Rules in the Console
            </TStrong></FTBody>
            <StackL />
            <FTBody>
                Rules are applied based on priority.
                Only the highest-ranking Rule with matching criteria is applied.
                This allows you to create Rules with specific exemptions that will override more broad Rules.
            </FTBody>
            <StackL />
            <FTHeading>Common Use Case</FTHeading>
            <StackL />
            <FTBody>
                To prevent known safe sites from being Isolated,
                add an Exclusion Rule that matches with a Custom Category for your &quot;Never Isolate URLs.&quot;
            </FTBody>
            <StackL />
            <FuseConsoleCardFooter text={'The system prioritizes Exclusion Rules before all other Rules.'}/>
        </Card>;
    }

    render() {
        const { policyTable } = this.props.policy.exclusionRules;

        return <Fragment>
            <Page title="Policies - Exclusion Rules">
                {this.renderTable()}
                {this.renderAboutSection()}
            </Page>

            <ExclusionRulesModal />
            <BrowsingRoleModal />
            <CustomCategoriesModal />

            <PriorityModal
                store={policyTable}
                subTitle={' - Exclusion Rules'}
                errMsg={'Failed to change rules priorities'}
            >
                {this.renderTable(true)}
            </PriorityModal>
            <ConcurrencyPopUp
                store={policyTable.concurrencyPopUpStore}
                revisionType={RULE_REC_TYPE.EXCLUSION_RULES}
            />
        </Fragment>;
    }
}

export default inject('console', 'policy')(observer(ExclusionRules));
